import { Component, ReactNode } from 'react';
import { ComingSoon } from './ComingSoon';
import { FeatureToggle } from './FeatureToggle';
interface FeatureOrComingSoonProps {
    name: string;
    strict?: boolean;
    children?: ReactNode;
}

export class FeatureOrComingSoon extends Component<FeatureOrComingSoonProps> {
    render() {
        const { children, ...rest } = this.props;

        return (
            <FeatureToggle {...rest} fallback={ComingSoon}>
                {children}
            </FeatureToggle>
        );
    }
}
